import React, { forwardRef } from "react";
import { Input } from "./styled";

export const CellInput = forwardRef(
  ({ error, color = "#fff", ...rest }, ref) => {
    return <Input ref={ref} $error={error} $color={color} {...rest} />;
  },
);

CellInput.displayName = "forward(CellInput)";
